import type {
  BeginProductCreatePayload,
  DataLayerEventName,
  DataLayerEventParams,
  PurchaseSamplePayload,
  SaveTemplatePayload,
  SignInPayload,
  SignOutPayload,
  SignUpPayload,
  StoreConnectedPayload,
  UserPropertyPayload,
  ViewItemPayload,
  ViewThumbnailPayload,
} from './gtm.types';

// 이 파일은 product-master-admin 등 다른 앱의 webpack 빌드에서도
// cross-app import 로 컴파일된다. 그 앱들의 tsconfig 는 art-cloud 의
// react-app.d.ts 를 include 하지 않으므로 ambient Window augmentation
// 이 적용되지 않는다. 따라서 window 타입을 모듈 내부에서 직접 좁힌다.
type DataLayerWindow = Window & {
  dataLayer?: Array<Record<string, unknown>>;
};

function pushDataLayer(
  event: DataLayerEventName,
  params?: DataLayerEventParams,
): void {
  if (typeof window === 'undefined') return;
  const w = window as DataLayerWindow;
  w.dataLayer = w.dataLayer ?? [];
  w.dataLayer.push({ event, ...params });
}

function trackSignUp(payload: SignUpPayload): void {
  pushDataLayer('sign_up', { memberData: payload });
}

function trackSignIn(payload: SignInPayload): void {
  pushDataLayer('sign_in', { memberData: payload });
}

function trackUserProperty(payload: UserPropertyPayload): void {
  pushDataLayer('user_property', { memberData: payload });
}

function trackSignOut(payload: SignOutPayload): void {
  pushDataLayer('sign_out', { memberData: payload });
}

function trackViewItem(payload: ViewItemPayload): void {
  pushDataLayer('view_item', payload);
}

function trackBeginProductCreate(payload: BeginProductCreatePayload): void {
  pushDataLayer('begin_product_create', payload);
}

function trackViewThumbnail(payload: ViewThumbnailPayload): void {
  pushDataLayer('view_thumbnail', payload);
}

function trackStoreConnected(payload: StoreConnectedPayload): void {
  pushDataLayer('store_connected', payload);
}

function trackPurchaseSample(payload: PurchaseSamplePayload): void {
  pushDataLayer('purchase_sample', payload);
}

function trackSaveTemplate(payload: SaveTemplatePayload): void {
  pushDataLayer('save_template', payload);
}

export {
  pushDataLayer,
  trackSignUp,
  trackSignIn,
  trackUserProperty,
  trackSignOut,
  trackViewItem,
  trackBeginProductCreate,
  trackViewThumbnail,
  trackStoreConnected,
  trackPurchaseSample,
  trackSaveTemplate,
};
